import React, { useContext } from "react";
import { AppContext } from "../States/AppContext";
import { useNavigate } from "react-router-dom";

import {
  PopUpBox,
  PopUpButtonWrapper,
  PopUpStandByButtonCancel,
  PopUpStandByButtonConfirm,
  PopUpStandbyMessage,
  PopUpStandbyWrapFlex,
  PopUpStandbyWrapFlexContainer,
} from "./PopUp.elements";

const PopUpStandby = () => {
  const { state, setState } = useContext(AppContext);

  const navigate = useNavigate();

  function handleBackButtonClick() {
    const scrollPosition = window.pageYOffset;
    window.history.back();
    setTimeout(() => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          window.scrollTo(0, element.offsetTop);
        }
      } else {
        window.scrollTo(0, scrollPosition);
      }
    }, 0);
  }

  function handleSubmit() {
    setState((prevState) => ({
      ...prevState,
      standBy: true,
      telemetry: true,
      piicConnected: false,
    }));

    setTimeout(() => {
      // navigate("/standbyscreen");
      navigate("/");
      // setState((prevState) => ({...prevState, }))
    }, 2000); //
  }

  return (
    <>
      <PopUpBox>
        <PopUpStandbyMessage>
          Enter Standby for selected <br></br> time?{" "}
        </PopUpStandbyMessage>
        <PopUpStandbyWrapFlexContainer>
          <PopUpStandbyWrapFlex>
            <label>
              <input
                type="radio"
                name="time"
                value="10min"
                id="10min"
                onChange={() =>
                  setState((prevState) => ({
                    ...prevState,
                    standbyTime: "10min",
                  }))
                }
              />
              10 min
            </label>
            <label>
              <input
                type="radio"
                name="time"
                value="20min"
                id="20min"
                onChange={() =>
                  setState((prevState) => ({
                    ...prevState,
                    standbyTime: "20min",
                  }))
                }
              />
              20 min
            </label>
            <label>
              <input
                type="radio"
                name="time"
                value="1h"
                id="1h"
                onChange={() =>
                  setState((prevState) => ({
                    ...prevState,
                    standbyTime: "1h",
                  }))
                }
              />
              1 h
            </label>
          </PopUpStandbyWrapFlex>
          <PopUpStandbyWrapFlex>
            <label>
              <input
                type="radio"
                name="time"
                value="2h"
                id="2h"
                onChange={() =>
                  setState((prevState) => ({
                    ...prevState,
                    standbyTime: "2h",
                  }))
                }
              />
              2 h
            </label>
            <label>
              <input
                type="radio"
                name="time"
                value="3h"
                id="3h"
                onChange={() =>
                  setState((prevState) => ({
                    ...prevState,
                    standbyTime: "3h",
                  }))
                }
              />
              3 h
            </label>
            <label>
              <input
                type="radio"
                name="time"
                value="infinite"
                id="infinite"
                onChange={() =>
                  setState((prevState) => ({
                    ...prevState,
                    standbyTime: "infinite",
                  }))
                }
              />
              Infinite
            </label>
          </PopUpStandbyWrapFlex>
        </PopUpStandbyWrapFlexContainer>

        <PopUpButtonWrapper>
          <PopUpStandByButtonCancel onClick={handleBackButtonClick}>
            Cancel
          </PopUpStandByButtonCancel>
          <PopUpStandByButtonConfirm onClick={handleSubmit}>
            Confirm
          </PopUpStandByButtonConfirm>
        </PopUpButtonWrapper>
      </PopUpBox>
    </>
  );
};

export default PopUpStandby;
